import React from "react"

import KnowledgeListItem from "./KnowledgeListItem"

const ModeratedKnowledgeListItem = props => (
    <KnowledgeListItem showApproved={true} {...props} />
)

export default ModeratedKnowledgeListItem
